import Vue from 'vue'

export default {
  state: {
    commonData: {
      isLoaded: false, // true когда все данные с сервера подгружены успешно

      users: null,
      usersThatExist: null,
      usersGroups: null,

      news: null,

      financeBoxes: null,
      financeBoxesThatExist: null,
      financeTagsAsTree: null,
      financeTagsAsListOfIndexes: null,

      tasks: null,
      taskForEdit: null,
      taskBoards: null,
      taskBoardForChangeSettings: null
    }
  },
  getters: {
    commonData: state => state.commonData
  },
  mutations: {
    commonDataIsLoadedSet (state, value) {
      state.commonData.isLoaded = value
    },

    // ////////////////////////////////////////////

    commonDataUsersSet (state, value) {
      state.commonData.users = value
    },
    commonDataUsersThatExistSet (state, value) {
      state.commonData.usersThatExist = value
    },
    commonDataUsersGroupsSet (state, value) {
      state.commonData.usersGroups = value
    },
    commonDataNewsSet (state, value) {
      state.commonData.news = value
    },
    commonDataFinanceBoxesSet (state, value) {
      state.commonData.financeBoxes = value
    },
    commonDataFinanceBoxesThatExistSet (state, value) {
      state.commonData.financeBoxesThatExist = value
    },
    commonDataFinanceTagsAsTreeSet (state, value) {
      state.commonData.financeTagsAsTree = value
    },
    commonDataFinanceTagsListOfIndexesSet (state, value) {
      state.commonData.financeTagsListOfIndexes = value
    },

    // ////////////////////////////////////////////

    commonDataTasksSet (state, value) {
      state.commonData.tasks = value
    },
    commonDataTaskValSet (state, value) {
      Vue.set(state.commonData.tasks[value.id], 'val', value)
    },
    commonDataTaskPropertySet (state, {id, prop, value}) {
      let props = prop.split('.')
      if ((props[1] == null) && (props[2] == null)) {
        Vue.set(state.commonData.tasks[id], props[0], value)
      }
      if ((props[1] != null) && (props[2] == null)) {
        Vue.set(state.commonData.tasks[id][props[0]], props[1], value)
      }
      if ((props[1] != null) && (props[2] != null)) {
        Vue.set(state.commonData.tasks[id][props[0]][props[1]], props[2], value)
      }
    },
    commonDataTasksAdd (state, value) {
      Vue.set(state.commonData.tasks, value.val.id, value)
    },
    commonDataTasksRemove (state, id) {
      Vue.set(state.commonData.tasks, id, null)
      delete state.commonData.tasks[id]
    },
    commonDataTaskForEditSet (state, value) {
      state.commonData.taskForEdit = value
    },
    commonDataTaskForEditValSet (state, value) {
      state.commonData.taskForEdit.val = value
    },

    // ////////////////////////////////////////////

    commonDataTaskBoardsSet (state, value) {
      state.commonData.taskBoards = value
    },
    // должно называться commonDataTaskBoardsValSet
    // а еще лучше переименовать в commonDataTaskBoardsPropertySet и как наверху переделать код
    commonDataTaskBoardsEditVal (state, value) {
      Vue.set(state.commonData.taskBoards[value.id], 'val', value)
    },
    commonDataTaskBoardsAdd (state, value) {
      Vue.set(state.commonData.taskBoards, value.val.id, value)
    },
    commonDataTaskBoardsRemove (state, id) {
      Vue.set(state.commonData.taskBoards, id, null)
    },
    commonDataTaskBoardForChangeSettingsSet (state, value) {
      state.commonData.taskBoardForChangeSettings = value
    },
    // должно называться commonDataTaskBoardForChangeSettingsValSet
    // а еще лучше переименовать в commonDataTaskBoardForChangeSettingsPropertySet и как наверху переделать код
    commonDataTaskBoardForChangeSettingsSetVal (state, value) {
      state.commonData.taskBoardForChangeSettings.val = value
    }
  },
  actions: {
    commonDataUsersSet ({commit}, value) {
      commit('commonDataUsersSet', value)
    },
    commonDataUsersThatExistSet ({commit}, value) {
      commit('commonDataUsersThatExistSet', value)
    },
    commonDataUsersGroupsSet ({commit}, value) {
      commit('commonDataUsersGroupsSet', value)
    },
    commonDataNewsSet ({commit}, value) {
      commit('commonDataNewsSet', value)
    },
    commonDataFinanceBoxesSet ({commit}, value) {
      commit('commonDataFinanceBoxesSet', value)
    },
    commonDataFinanceBoxesThatExistSet ({commit}, value) {
      commit('commonDataFinanceBoxesThatExistSet', value)
    },
    commonDataFinanceTagsAsTreeSet ({commit}, value) {
      commit('commonDataFinanceTagsAsTreeSet', value)
    },
    commonDataFinanceTagsListOfIndexesSet ({commit}, value) {
      commit('commonDataFinanceTagsListOfIndexesSet', value)
    },
    commonDataTasksSet ({commit}, value) {
      commit('commonDataTasksSet', value)
    },
    commonDataTaskBoardsSet ({commit}, value) {
      commit('commonDataTaskBoardsSet', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/storeCommonData.js